var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-top"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"tit"},[_c('strong',[_vm._v("botalab")]),_vm._v(" PRODUCTS ")]),_c('p',{staticClass:"desc mt-2"},[_vm._v("하루의 시작과 끝을 편안하게 "),_c('span',{staticClass:"mbr"}),_vm._v("Hair , Body Care")])])])
}]

export { render, staticRenderFns }